/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

qds-web-carousel {
  padding: 0 var(--qds-navigation-padding-horizontal) 56px;
}
